import { LockOutlined } from '@ant-design/icons';
import Ellipsis from 'ant-design-pro/lib/Ellipsis';
import React, { FC } from 'react';

const TitleWithLock: FC<any> = ({
	isLocked,
	className,
	children,
	containerClassName,
	icon,
}): React.ReactElement => {
	return (
		<div className={`flex flex-row items-baseline ${containerClassName || ''}`}>
			<div>{icon}</div>
			<div
				style={{ ...(isLocked && { maxWidth: '65%' }) }}
				className={`overflow-hidden text-ellipsis ${className || ''}`}
			>
				{children}
			</div>
			{isLocked ? (
				<div className="ml-2">
					<LockOutlined translate="" />
				</div>
			) : null}
		</div>
	);
};

export default TitleWithLock;
